import { useContext } from "react";
import AlertContext from "../context/AlertContext";

const useAuth=()=>{
    return useContext(AlertContext)
}
export default useAuth;